import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { QRScanComponent } from 'app/layout/common/qrscan/qrscan.component';
import { SharedModule } from 'app/shared/shared.module';
// import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';

@NgModule({
    declarations: [
        QRScanComponent
    ],
    imports     : [
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        SharedModule,
        // NgxQRCodeModule
    ],
    exports     : [
        QRScanComponent
    ]
})
export class QRScanModule
{
}
